export const homeConstants = {
  GET_HOME_DATA_FAILURE: "GET_HOME_DATA_FAILURE",
  GET_HOME_DATA_SUCCESS: "GET_HOME_DATA_SUCCESS",
};
